
import { useState, useEffect } from 'react';
import { Category } from '@/types/assessment';

export function useQuestionState(categories: Category[]) {
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>('');
  const [isAddingQuestion, setIsAddingQuestion] = useState(false);
  const [editingQuestionId, setEditingQuestionId] = useState<string | null>(null);

  // Select first category by default if none selected
  useEffect(() => {
    if (categories.length > 0 && !selectedCategoryId) {
      setSelectedCategoryId(categories[0].id);
    }
  }, [categories, selectedCategoryId]);

  // Get the currently selected category
  const selectedCategory = categories.find(c => c.id === selectedCategoryId);

  return {
    selectedCategoryId,
    setSelectedCategoryId,
    isAddingQuestion,
    setIsAddingQuestion,
    editingQuestionId,
    setEditingQuestionId,
    selectedCategory
  };
}
